"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polyfillIntlRtf = polyfillIntlRtf;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function polyfillIntlRtf() {
  return _polyfillIntlRtf.apply(this, arguments);
}
function _polyfillIntlRtf() {
  _polyfillIntlRtf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var polyfillLocale;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@formatjs/intl-getcanonicallocales/polyfill"));
          });
        case 2:
          _context.next = 4;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@formatjs/intl-locale/polyfill"));
          });
        case 4:
          _context.next = 6;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@formatjs/intl-pluralrules/polyfill-force"));
          });
        case 6:
          _context.next = 8;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@formatjs/intl-numberformat/polyfill-force"));
          });
        case 8:
          _context.next = 10;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@formatjs/intl-relativetimeformat/polyfill-force"));
          });
        case 10:
          polyfillLocale = navigator && navigator.language ? navigator.language.substring(0, 2) : "en"; // Webpack doesn't like having import statements with dynamic values like /locale-data/${polyfillLocale}
          // and throws a warning, to avoid this we have a switch that imports depending on the user's navigator language
          // this also includes "en" as our fallback in case the user has none set up
          _context.t0 = polyfillLocale;
          _context.next = _context.t0 === "ar" ? 14 : _context.t0 === "cs" ? 21 : _context.t0 === "de" ? 28 : _context.t0 === "el" ? 35 : _context.t0 === "es" ? 42 : _context.t0 === "fr" ? 49 : _context.t0 === "hu" ? 56 : _context.t0 === "id" ? 63 : _context.t0 === "it" ? 70 : _context.t0 === "ja" ? 77 : _context.t0 === "ko" ? 84 : _context.t0 === "ms" ? 91 : _context.t0 === "pl" ? 98 : _context.t0 === "pt" ? 105 : _context.t0 === "ro" ? 112 : _context.t0 === "ru" ? 119 : _context.t0 === "th" ? 126 : _context.t0 === "vi" ? 133 : _context.t0 === "zh" ? 140 : _context.t0 === "en" ? 147 : 147;
          break;
        case 14:
          _context.next = 16;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/ar");
        case 16:
          _context.next = 18;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/ar");
        case 18:
          _context.next = 20;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/ar");
        case 20:
          return _context.abrupt("break", 154);
        case 21:
          _context.next = 23;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/cs");
        case 23:
          _context.next = 25;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/cs");
        case 25:
          _context.next = 27;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/cs");
        case 27:
          return _context.abrupt("break", 154);
        case 28:
          _context.next = 30;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/de");
        case 30:
          _context.next = 32;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/de");
        case 32:
          _context.next = 34;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/de");
        case 34:
          return _context.abrupt("break", 154);
        case 35:
          _context.next = 37;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/el");
        case 37:
          _context.next = 39;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/el");
        case 39:
          _context.next = 41;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/el");
        case 41:
          return _context.abrupt("break", 154);
        case 42:
          _context.next = 44;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/es");
        case 44:
          _context.next = 46;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/es");
        case 46:
          _context.next = 48;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/es");
        case 48:
          return _context.abrupt("break", 154);
        case 49:
          _context.next = 51;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/fr");
        case 51:
          _context.next = 53;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/fr");
        case 53:
          _context.next = 55;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/fr");
        case 55:
          return _context.abrupt("break", 154);
        case 56:
          _context.next = 58;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/hu");
        case 58:
          _context.next = 60;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/hu");
        case 60:
          _context.next = 62;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/hu");
        case 62:
          return _context.abrupt("break", 154);
        case 63:
          _context.next = 65;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/id");
        case 65:
          _context.next = 67;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/id");
        case 67:
          _context.next = 69;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/id");
        case 69:
          return _context.abrupt("break", 154);
        case 70:
          _context.next = 72;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/it");
        case 72:
          _context.next = 74;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/it");
        case 74:
          _context.next = 76;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/it");
        case 76:
          return _context.abrupt("break", 154);
        case 77:
          _context.next = 79;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/ja");
        case 79:
          _context.next = 81;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/ja");
        case 81:
          _context.next = 83;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/ja");
        case 83:
          return _context.abrupt("break", 154);
        case 84:
          _context.next = 86;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/ko");
        case 86:
          _context.next = 88;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/ko");
        case 88:
          _context.next = 90;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/ko");
        case 90:
          return _context.abrupt("break", 154);
        case 91:
          _context.next = 93;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/ms");
        case 93:
          _context.next = 95;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/ms");
        case 95:
          _context.next = 97;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/ms");
        case 97:
          return _context.abrupt("break", 154);
        case 98:
          _context.next = 100;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/pl");
        case 100:
          _context.next = 102;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/pl");
        case 102:
          _context.next = 104;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/pl");
        case 104:
          return _context.abrupt("break", 154);
        case 105:
          _context.next = 107;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/pt");
        case 107:
          _context.next = 109;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/pt");
        case 109:
          _context.next = 111;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/pt");
        case 111:
          return _context.abrupt("break", 154);
        case 112:
          _context.next = 114;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/ro");
        case 114:
          _context.next = 116;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/ro");
        case 116:
          _context.next = 118;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/ro");
        case 118:
          return _context.abrupt("break", 154);
        case 119:
          _context.next = 121;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/ru");
        case 121:
          _context.next = 123;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/ru");
        case 123:
          _context.next = 125;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/ru");
        case 125:
          return _context.abrupt("break", 154);
        case 126:
          _context.next = 128;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/th");
        case 128:
          _context.next = 130;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/th");
        case 130:
          _context.next = 132;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/th");
        case 132:
          return _context.abrupt("break", 154);
        case 133:
          _context.next = 135;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/vi");
        case 135:
          _context.next = 137;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/vi");
        case 137:
          _context.next = 139;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/vi");
        case 139:
          return _context.abrupt("break", 154);
        case 140:
          _context.next = 142;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/zh");
        case 142:
          _context.next = 144;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/zh");
        case 144:
          _context.next = 146;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/zh");
        case 146:
          return _context.abrupt("break", 154);
        case 147:
          _context.next = 149;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-pluralrules/locale-data/en");
        case 149:
          _context.next = 151;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-numberformat/locale-data/en");
        case 151:
          _context.next = 153;
          return function (specifier) {
            return new Promise(function (r) {
              return r(specifier);
            }).then(function (s) {
              return _interopRequireWildcard(require(s));
            });
          }("@formatjs/intl-relativetimeformat/locale-data/en");
        case 153:
          return _context.abrupt("break", 154);
        case 154:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _polyfillIntlRtf.apply(this, arguments);
}